import io from "socket.io-client";

const socket = io(process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000',
    {withCredentials: true});

const sessionId = sessionStorage.getItem("sessionId")
if(sessionId) {
    socket.auth = {sessionId}
    socket.sessionId = sessionId
}

socket.on("session", ({sessionId}) => {
    console.log("Received session id: " + sessionId)
    socket.auth = {sessionId}
    socket.sessionId = sessionId
    sessionStorage.setItem("sessionId", sessionId)
    window.dispatchEvent(new CustomEvent('session-id-updated', {detail: {sessionId}}))
})

export default socket